import { AllColumn, ImportColumn, SelectedColumn, UpdateColumn } from "../data/columns";
const Privilage = {
    export: 'Export',
    import: 'Import',
    update: 'Update',
    delete: 'Delete',
    approve: 'Approve',
    addMetaData:'AddMetaData',
    
}

const Role ={
    trader:[Privilage.import],
    traderBD:[Privilage.import,Privilage.addMetaData,Privilage.delete],
    masterDataUser:[Privilage.import,Privilage.addMetaData,Privilage.update,Privilage.delete,Privilage.approve,Privilage.export]
}
export const isCanExport = ()=>{
    let flag = false;
    flag = checkPrivilage(Privilage.export);
    return flag;
}
export const isCanImport = ()=>{
    let flag = false;
    flag = checkPrivilage(Privilage.import);
    return flag;
}
export const isCanUpdate = ()=>{
    let flag = false;
    flag = checkPrivilage(Privilage.update);
    return flag;
}
export const isCanDelete = ()=>{
    let flag = false;
    flag = checkPrivilage(Privilage.delete);
    return flag;
}
export const isCanApprove = ()=>{
    let flag = false;
    flag = checkPrivilage(Privilage.approve);
    return flag;
}
export const isCanAddMetaData = ()=>{
    let flag = false;
    flag = checkPrivilage(Privilage.addMetaData);
    return flag;
}
const checkPrivilage = (privilageText) => {
    let flag = false;
    const payload = parseJwt();
    if(Role[`${payload.role}`] instanceof Array){
        flag = Role[`${payload.role}`].includes(privilageText)
    }
    return flag;
}

const parseJwt = () => {
    const token = localStorage.getItem("token_JWT");
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    //console.log(JSON.parse(jsonPayload)+" JSON : "+jsonPayload)
    return JSON.parse(jsonPayload);
};

export const currentUserName = () => {
    let name = "";
    const payload = parseJwt();
    if(payload.name){
        name = payload.name;
    }
   // console.log("NAME : "+name)
    return name;
}

export const currentOrganizationName = () => {
    let organization = "";
    const payload = parseJwt();
    if(payload.organization){
        organization = payload.organization;
    }
    //console.log("org  : "+organization)
    return organization;
}

export const getRoleBasedColumns = () => {
    let allColumn = [];
    const payload = parseJwt();
    if(Role[`${payload.role}`] instanceof Array){
        Role[`${payload.role}`].map(privilage => {
            allColumn.push.apply(allColumn , getColumnsByPrivilage(privilage));
            return privilage;
        });
    }
    allColumn = removeDuplicateColumns(allColumn)
     //console.log("role based  : "+allColumn)
    return allColumn;
}
const removeDuplicateColumns = (arr)=>{
    var result = arr.reduce((unique, o) => {
        if(!unique.some(obj => obj.field === o.field && obj.header === o.header)) {
          unique.push(o);
        }
        return unique;
    },[]);
    
    return result;
}
const getColumnsByPrivilage= (privilageText) => {
    let columns = [];
    switch (privilageText) {
        case Privilage.import:
            columns = ImportColumn;
            return columns;
        case Privilage.update:
            columns = UpdateColumn;
            return columns;
        case Privilage.approve:
            columns = AllColumn;
            return columns;
        default:
            columns = SelectedColumn;
            return columns;
    }
    
}
export const currentRoleName = () => {
    let role = "";
    const payload = parseJwt();
    if(payload.role){
        role = payload.role;
    }
    //console.log("role  : "+role)
    return role;
}